import React from 'react';
import toast, { Toast } from 'react-hot-toast';
import { revertAiBatch } from '../../api';

interface AiUndoToastOptions {
  batchId: string;
  /** Body of the toast, e.g. "AI assigned drivers to 12 accounts" */
  message: string;
  /** Success toast shown after a successful revert */
  revertedMessage: string;
  /** Called after a successful revert (typically refetch) */
  onReverted?: () => void;
}

/**
 * Shared success toast with an Undo button for AI batch commits
 * (Build with AI drivers, AI rooms forecast). Undo calls revertAiBatch
 * and then invokes onReverted so the caller can refresh the grid.
 */
export function showAiUndoToast({ batchId, message, revertedMessage, onReverted }: AiUndoToastOptions): void {
  toast(
    (t: Toast) => (
      <div className="flex items-center gap-3">
        <span className="text-sm">{message}</span>
        <button
          onClick={async () => {
            toast.dismiss(t.id);
            try {
              await revertAiBatch(batchId);
              toast.success(revertedMessage);
              onReverted?.();
            } catch (error) {
              console.error('Failed to revert AI batch:', error);
              toast.error('Failed to undo AI changes');
            }
          }}
          className="flex-shrink-0 px-2.5 py-1 text-xs font-semibold rounded-md"
          style={{ background: 'var(--lodge-orange-400)', color: '#ffffff', border: 'none' }}
        >
          Undo
        </button>
      </div>
    ),
    { duration: 10000, icon: '✨' }
  );
}
